<template>

    <vs-card>
        <vs-row>
            <vs-col>
                <table class="r-table">
                    <thead>
                        <tr>
                            <th class="r-table-th">

                            </th>
                            <th class="r-table-th">
                                {{ month != '' ? month : '-' }}
                            </th>
                            <th class="r-table-th">
                                Acumulado  a {{ month != '' ? month : '-' }}
                            </th>
                            <th class="r-table-th">
                                Presupuesto  Mensual
                            </th>
                            <th class="r-table-th">
                                Presupuesto  Acumulado
                            </th>
                            <th class="r-table-th">
                                Variación  Absoluta
                            </th>
                            <th class="r-table-th">
                                Variación Porcentual ({{ month != '' ? month : '-' }})
                            </th>
                            <th class="r-table-th">
                                Variación Absoluta Acumulada
                            </th>
                            <th class="r-table-th">
                                Variación Porcentual (Acumulada)
                            </th>

                            <th class="r-table-th">
                                Utilizacion Mensual <br>({{formatCell(budget.period.utilization_month, '%') }})
                            </th>
                            <th class="r-table-th">
                                Utilizacion Acumulada <br> ({{formatCell(budget.period.utilization_month, '%') }})
                            </th>
                        </tr>

                    </thead>
                    <tbody>
                        <tr @click="changeTable('budget')">
                            <td class="f-upper">
                                DEPTS.
                            </td>
                            <td :data-label="month != '' ? month : '-'" class="text-right">
                                {{ formatCell(budget.totals.expense_total_month, '$') }}
                            </td>
                            <td :data-label="`Acumulado a ${month != '' ? month : '-'}`" class="text-right">
                                {{ formatCell(budget.totals.expense_accumulated, '$') }}
                            </td>
                            <td data-label="Presupuesto Mensual" class="text-right">
                                {{ formatCell(budget.totals.budget_total_month, '$') }}
                            </td>
                            <td data-label="Presupuesto Acumulado" class="text-right">
                                {{ formatCell(budget.totals.budget_accumulated, '$') }}
                            </td>
                            <td data-label="Variación Absoluta" :class="[backgroundColor(budget.totals.expense_total_month, budget.totals.budget_total_month), 'text-right']">
                                {{ formatCell(budget.totals.variation_month, '$') }}
                            </td>

                            <td :data-label="`Variación Porcentual % (${month != '' ? month : '-'})`" :class="[backgroundColor(budget.totals.expense_total_month, budget.totals.budget_total_month), 'text-right']">
                                {{ formatCell(budget.totals.variation_porcentage_month, '%') }}
                            </td>
                            <td data-label="Variación Absoluta Acumulada" :class="[backgroundColor(budget.totals.expense_accumulated, budget.totals.budget_accumulated), 'text-right' ]">
                                {{ formatCell(budget.totals.variation_accumulated, '$') }}
                            </td>
                            <td data-label="Variación Porcentual % (Acumulada)" :class="[backgroundColor(budget.totals.expense_accumulated, budget.totals.budget_accumulated), 'text-right' ]">
                                {{ formatCell(budget.totals.variation_porcentage_accumulated, '%') }}
                            </td>
                            <td data-label="Utilizacion Mensual" :class="[utilizationBg(budget.totals.expense_total_month, budget.totals.budget_total_month, budget.period.utilization_month), 'text-right']">
                                {{ formatCell(budget.totals.utilization_month, '%') }}
                            </td>
                            <td data-label="Utilizacion Acumulada" :class="[utilizationBg(budget.totals.expense_accumulated, budget.totals.budget_accumulated, budget.period.utilization_accumulated), 'text-right']">
                                {{ formatCell(budget.totals.utilization_accumulated, '%') }}
                            </td>

                        </tr>
                        <tr  @click="changeTable('tax')">
                            <td class="f-upper">
                                Taxes & Interest
                            </td>
                            <td :data-label="month != '' ? month : '-'" class="text-right">
                                {{ formatCell(tax.totals.expense_total_month, '$') }}
                            </td>
                            <td :data-label="`Acumulado a ${month != '' ? month : '-'}`" class="text-right">
                                {{ formatCell(tax.totals.expense_accumulated, '$') }}
                            </td>
                            <td data-label="Presupuesto Mensual" class="text-right">
                                {{ formatCell(tax.totals.budget_total_month, '$') }}
                            </td>
                            <td data-label="Presupuesto Acumulado" class="text-right">
                                {{ formatCell(tax.totals.budget_accumulated, '$') }}
                            </td>
                            <td data-label="Variación Absoluta" :class="[backgroundColor(tax.totals.expense_total_month, tax.totals.budget_total_month), 'text-right']">
                                {{ formatCell(tax.totals.variation_month, '$') }}
                            </td>

                            <td :data-label="`Variación Porcentual (${month != '' ? month : '-'})`" :class="[backgroundColor(tax.totals.expense_total_month, tax.totals.budget_total_month), 'text-right']">
                                {{ formatCell(tax.totals.variation_porcentage_month, '%') }}
                            </td>
                            <td data-label="Variación Absoluta Acumulada" :class="[backgroundColor(tax.totals.expense_accumulated, tax.totals.budget_accumulated), 'text-right' ]">
                                {{ formatCell(tax.totals.variation_accumulated, '$') }}
                            </td>
                            <td data-label="Variación Porcentual (Acumulada)" :class="[backgroundColor(tax.totals.expense_accumulated, tax.totals.budget_accumulated), 'text-right' ]">
                                {{ formatCell(tax.totals.variation_porcentage_accumulated, '%') }}
                            </td>
                            <td data-label="Utilizacion Mensual" :class="[utilizationBg(tax.totals.expense_total_month, tax.totals.budget_total_month, tax.period.utilization_month), 'text-right']">
                                {{ formatCell(tax.totals.utilization_month, '%') }}
                            </td>
                            <td data-label="Utilizacion Acumulada" :class="[utilizationBg(tax.totals.expense_accumulated, tax.totals.budget_accumulated, tax.period.utilization_accumulated), 'text-right']">
                                {{ formatCell(tax.totals.utilization_accumulated, '%') }}
                            </td>
                        </tr>
                        <tr class="font-bold">
                            <td class="f-upper">
                                {{ $t('total') }}
                            </td>
                            <td :data-label="month != '' ? month : '-'" class="text-right">
                                {{ formatCell(budget.totals.expense_total_month + tax.totals.expense_total_month,
                                    '$') }}
                            </td>
                            <td :data-label="`Acumulado a ${month != '' ? month : '-'}`" class="text-right">
                                {{ formatCell(budget.totals.expense_accumulated + tax.totals.expense_accumulated,
                                    '$') }}
                            </td>
                            <td data-label="Presupuesto Mensual" class="text-right">
                                {{ formatCell(budget.totals.budget_total_month + tax.totals.budget_total_month, '$')
                                }}
                            </td>
                            <td data-label="Presupuesto Acumulado" class="text-right">
                                {{ formatCell(budget.totals.budget_accumulated + tax.totals.budget_accumulated, '$')
                                }}
                            </td>
                            <td data-label="Variación Absoluta" class="text-right">
                                {{ formatCell(budget.totals.variation_month + tax.totals.variation_month, '$') }}
                            </td>

                            <td :data-label="`Variación Porcentual (${month != '' ? month : '-'})`" class="text-right">
                                {{ formatCell(budget.totals.variation_porcentage_month, '%') }}
                            </td>
                            <td data-label="Variación Absoluta Acumulada" class="text-right">
                                {{ formatCell(budget.totals.variation_accumulated +
                                    tax.totals.variation_accumulated, '$') }}
                            </td>
                            <td data-label="Variación Porcentual(Acumulada)" class="text-right">
                                {{ formatCell(budget.totals.variation_porcentage_accumulated, '%') }}
                            </td>
                            <td data-label="Utilizacion Mensual" class="text-right">
                                {{ formatCell(budget.totals.utilization_month, '%') }}
                            </td>
                            <td data-label="Utilizacion Acumulada" class="text-right">
                                {{ formatCell(budget.totals.utilization_accumulated, '%') }}
                            </td>

                        </tr>
                    </tbody>
                </table>
            </vs-col>
        </vs-row>
    </vs-card>
</template>

<script>


export default {
    methods: {
        formatCell(value, sim) {
            if (value == '0') {
                return '-'
            }
            return `${sim == '$' ? '$' : ''} ${this.formatNumber(value, 2)} ${sim == '%' ? '%' : ''}`
        },
        backgroundColor(value1, value2) {
            const x = Number(value1)
            const y = Number(value2)
            if (x == 0 && y == 0) {
                return 'col-grey';
            }
            let css = '';

            if (x > y) {
                css = 'col-danger';
            }

            if (x <= y) {
                css = 'col-success';
            }

            return css;
        },
        utilizationBg(value1, value2, value3) {
            const x = Number(value1);
            const y = Number(value2);
            const p = Number(value3);

            if (x == 0 || y == 0) {
                return 'col-grey';
            }
            const result = (value1 / value2) * 100

            let css = ''
            if (result <= p) {
                css = 'col-success';
            }

            if (result > p && result <= 100) {
                css = 'col-warning';
            }


            if (result > 100) {
                css = 'col-danger';
            }

            return css;

        },
        changeTable(table){
            console.log(table)
            this.$emit('changeTable',table)
        }
    },
    props: {
        tax: {
            type: Object,
            default: () => ({}),
        },
        budget: {
            type: Object,
            default: () => ({}),
        },
        month: {
            type: String,
            default: () => '',
        },
    }
}
</script>

<style scoped>
.col-success {
  background: #28c76f;
  color: #ffffff;
}

.col-danger {
  background: #bc1300;
  color: #ffffff;
}

.col-warning {
  background: #FF9F43;
  color: #ffffff;
}

.col-grey {
  background: #b8c2cc;
  color: #000000;
}

.r-table {
    border-collapse: collapse;
    margin: 0;
    padding: 0;
    width: 100%;
    table-layout: fixed;
}




.r-table th,
.r-table td {
    padding: .5em .5em;
    text-align: center;
    font-size: 1em;
}

.r-table th {
    text-transform: uppercase;
    color: #BC1300;
    font-size: 1em;
}

.r-table tr:hover td {
    /* padding: 1em ; */
    font-weight: bold;
  }

@media screen and (max-width: 600px) {
    .r-table {
        border: 0;
    }

    .r-table caption {
        font-size: 1.3em;
    }

    .r-table thead {
        border: none;
        clip: rect(0 0 0 0);
        height: 1px;
        margin: -1px;
        overflow: hidden;
        padding: 0;
        position: absolute;
        width: 1px;
    }

    .r-table th {
        color: #BC1300;
        font-size: 1.2em;
    }

    .r-table tr {
        display: block;
        margin-bottom: .625em;
    }

    .r-table td {
        display: block;
        font-size: .8em;
        text-align: right;
    }

    .r-table td::before {
        content: attr(data-label);
        float: left;
        font-weight: bold;
        text-transform: uppercase;
        color: #BC1300;
    }

    .r-table td:last-child {
        border-bottom: 0;
    }
}
</style>